module.exports = "../dist/frontend/icons/symbols/cards/white.svg?aca2dabb715276222d4859b280e6d45b";